import { PermissionT } from "../types";

export const marketingView = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "marketing_view");
  return !!p;
};

export default marketingView;
